import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'; 

import 'babel-polyfill';

import 'bootstrap';

import './Static/Css/bootstrap.min.css';
import './Static/Css/bootstrap-grid.min.css';
import './Static/Css/bootstrap-reboot.min.css';

import './App.css';

import './../node_modules/@fortawesome/fontawesome-free/css/all.css';

import Client from './Components/Views/Client/Client';
import ClientEdit from './Components/Views/Client/ClientEdit';

import CarsEdit from './Components/Views/Car/CarsEdit';
import CarEdit from './Components/Views/Car/CarEdit';

import OpinionsEdit from './Components/Views/Opinion/OpinionsEdit';

import ApvsEdit from './Components/Views/APV/ApvsEdit';

import RelationsEdit from './Components/Views/Relation/RelationsEdit';

import Login from './Components/Views/Login';

import UsersEdit from './Components/Views/User/UsersEdit';

import Search from './Components/Views/Search/Search';
import Geo from './Components/Views/Geo/Geo';

import Rework from './Components/Views/Rework/Rework';

import Alert from './Components/Views/Alert/Alert';

import Convert from './Components/Views/Convert/Convert';

import Flash from './Components/Views/Flash/Flash';

import Conseilor from './Components/Views/Conseilor/Conseilor';

import Proposal from './Components/Views/Proposal/Proposal';

const App = () => {
  return (
  <Router>
    <Switch>
        <Route exact path="/client/edit/:id" component={ ClientEdit } />
        <Route exact path="/client/:id" component={ Client } />

        <Route exact path="/cars/edit/:id" component={ CarsEdit } />
        <Route exact path="/car/edit/:id" component={ CarEdit } />

        <Route exact path="/opinions/edit/:id" component={ OpinionsEdit } />

        <Route exact path="/apvs/edit/:id" component={ ApvsEdit } />

        <Route exact path="/relations/edit/:id" component={ RelationsEdit } />

        <Route exact path="/login" component={ Login } />

        <Route exact path="/users" component={ UsersEdit } />
        
        <Route exact path="/" component={ Search } />

        <Route exact path="/search" component={ Search } />
        <Route exact path="/search/:data" component={ Search } />


        <Route exact path="/geo" component={ Geo } />

        <Route exact path="/rework" component={ Rework } />

        <Route exact path="/alert" component={ Alert } />

        <Route exact path="/scan" component={ Convert } />

        <Route exact path="/flash" component={ Flash } />

        <Route exact path="/conseilor" component={ Conseilor } />

        <Route exact path="/proposal" component={ Proposal } />
    </Switch>
  </Router>
  );
};


export default App;



// WEBPACK FOOTER //
// ./src/App.js